import { Box, Link, Typography, styled } from '@mui/material'
import alcoholFree from 'assets/Icon/alcohol-free.png'
import parbenFree from 'assets/Icon/parben-free.png'
import parbenFreeTwo from 'assets/Icon/parben-free-1.png'

function ProductDescription({ selectedProduct }) {
  return (
    <ProductDescriptionCard selectedProduct={selectedProduct}>
      <Box width="100%" display="flex" alignItems="center" justifyContent="center" height="100%" flexDirection="column">
        <Box>
          <ProductTitle>
            <Typography fontSize="34px" fontWeight={800}>
              {selectedProduct?.texts?.title}
            </Typography>
          </ProductTitle>

          <ProductDescriptionText dangerouslySetInnerHTML={{ __html: selectedProduct?.texts?.description }} />
        </Box>
      </Box>

      <BottomSection>
        <USP mb={2}>
          <ul>
            <li>
              مرطوب‌کننده و محافظت‌کننده پوست لب
            </li>

            <li>
            تسکین‌دهنده و کاهش‌دهنده التهاب لب
            </li>

            <li>
              تغذیه‌کننده و حاوی ویتامین‌ها و عصاره‌های ضروری
            </li>

            <li>
              دارای SPF15
            </li>
          </ul>
        </USP>



        <Typography variant="subtitle2" mb={1} color="#ffffff" fontWeight={300} dir="rtl">
          <b>
            طریقه مصرف:
          </b>{" "}
          مقدار مورد نیاز از بالم لب را روی لب خود بزنید. می‌توانید به تنهایی برای استفاده روزانه، قبل از خواب، به عنوان پایه آرایش یا بعد از آن استفاده کنید.
        </Typography>

        <ImageWrapper>
          <Box display={"flex"} flexDirection={"column"} alignItems={"center"} textAlign={"center"} gap={1}> 
            <img src={alcoholFree} alt="" />
            <Typography sx={{fontSize: 10, color: "white"}} >
              ALCOHOL-FREE
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} alignItems={"center"} textAlign={"center"} gap={1}> 
            <img src={parbenFree} alt="" />
            <Typography sx={{fontSize: 10, color: "white"}} >
              LONG-LASTING HYDRATION
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} alignItems={"center"} textAlign={"center"} gap={1}> 
            <img src={parbenFreeTwo} alt="" />
            <Typography sx={{fontSize: 10, color: "white"}} >
              PARABEN-FREE
            </Typography>
          </Box>
        </ImageWrapper>

        <MaticanLink>
              <Link href="https://maticangroup.com/" target="_blank">
                By Matican Group LLC
              </Link>
            </MaticanLink>
      </BottomSection>

    </ProductDescriptionCard >
  )
}

const USP = styled(Box)(({ theme }) => ({
  direction: 'rtl',
  color: theme.palette.common.white,
  fontSize: '16px',
  gap: theme.spacing(3),
  flexWrap: 'wrap',
  fontWeight: 300,
  lineHeight: 1.7,
  marginBottom: theme.spacing(4),
  width: '100%',

  span: {
    flex: '1'
  }
}))

const MaticanLink = styled(Box)(({ theme, isOverview }) => ({
  position: "fixed",
  width: "100%",
  display: "flex",
  justifyContent: "end",
  bottom: "10px",
  right: "10px",
  zIndex: 9999999,
  a: {
    textDecoration: "none",
    fontSize: "9px",
    color: theme.palette.primary.contrastText,
  },
  [theme.breakpoints.down("md")]: {
    justifyContent: "center",
    bottom: "-18px",
    right: "0px",
    position: 'absolute',
    a: {
      fontSize: "8px",
    },
  },
}));

const ProductDescriptionCard = styled(Box)(({ theme, selectedProduct }) => ({
  position: 'relative',
  padding: theme.spacing(14, 6),
  transition: '0.3s all',
  zIndex: 0,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'column',

  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(6, 2, 3 , 2),
  },

  "&:before": {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    content: '""',
    backgroundSize: 'cover',
    backgroundImage: `url(${selectedProduct.background.img})`,
    backgroundPosition: 'bottom right',
    filter: 'blur(4px)',
    zIndex: -1,
    opacity: 0.2,
  }
}))

const ProductDescriptionText = styled("div")(({ theme }) => ({
  direction: 'rtl',
  color: theme.palette.common.white,
  fontSize: '16px',
  fontWeight: 400,
  width: '100%'
}))

const BottomSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  paddingTop: theme.spacing(4),
  marginTop: theme.spacing(6),

  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: "50%",
    height: '1px',
    background: '#ffffff',
  },

  ul: {
    paddingRight: theme.spacing(2),
  }
}))

const ProductTitle = styled(Box)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '20px',
  direction: 'rtl',
  marginBottom: theme.spacing(2),
  textAlign: 'right',

  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));


const ImageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: "space-evenly",
  margin: theme.spacing(2, 0),
  img: {
    padding: theme.spacing(0, 2, 0, 2),
    height: '100%',
    maxHeight: '80px',
    maxWidth: "80px",
    width: '100%',
    
    [theme.breakpoints.up('md')]: {
      maxHeight: '90px',
      maxWidth: "90px",
    }
  }
}))

export default ProductDescription